import React from 'react';

const TopBar = (props) => {
  return (
    <div className={props.className} style={{ ...props.style, backgroundColor: props.color, height: props.height ? props.height: '' }}>
      <div className="bloc-titre-topbar-contenu" style={{width: props.titleWidth}}>
        <div>{props.title}</div>
        {props.radioSelector}
        {props.filterContainer}
      </div>
      {props.buttons}
    </div>
  )
}

export default TopBar;
